module.exports = __webpack_public_path__ + "static/media/review1.ace77750.jpg";